import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useAdmin } from './useAdmin';

/**
 * Hook to get real-time count of pending marketplace listings
 */
export const usePendingMarketplaceItems = () => {
  const { isAdmin } = useAdmin();
  const [pendingCount, setPendingCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAdmin) {
      setLoading(false);
      return;
    }

    // Set up real-time listener for pending items
    const itemsRef = collection(db, 'marketplaceItems');
    const pendingQuery = query(itemsRef, where('status', '==', 'pending'));

    const unsubscribe = onSnapshot(
      pendingQuery,
      (snapshot) => {
        setPendingCount(snapshot.size);
        setLoading(false);
      },
      (error) => {
        console.error('Error listening to pending marketplace items:', error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [isAdmin]);

  return { pendingCount, loading };
};
